import { useState } from "react"
import { useAuth } from "../../../hooks/AuthContext"
import { useToast } from "../../../hooks/Toast"
import ContainerForm from "../../layout/Form/ContainerForm"
import { Selection } from "../../layout/Selection/Selection"
import './turmas.css'
import Input from "../../layout/Input/Input"
import { addItem, updateItem } from "../../../firebase/CRUD"
import Button from "../../layout/Button/Button"

export default function TurmaAdd({cadastramento,edit}){
    const {usuario} = useAuth()
    
    const {mostrarAviso} = useToast()
   
    const [formData, setFormData] = useState(edit || {
        nome: '',
        descricao: '',
        professor: '',
        grupo: ''
    })
    const handleInputChange = (e)=>{
        const {name, value} = e.target
        setFormData({
            ...formData,
            [name]: value
        })
    }
    
    const grupos = [
        {nome:'Berçário'},
        {nome:'Maternal'},
        {nome:'Primário'},
        {nome:'Juniores'},
        {nome:'Pré-adolescentes'},
        {nome:'Adolescentes'},
        {nome:'Juvenis'},
        {nome:'Jovens'},
        {nome:'Adultos'},
        {nome:'Discipulado'},
        {nome:'Classe Mista'}
    ]
    const salvar = (e)=>{
        e.preventDefault()
        if(edit)
            updateItem('turmas',edit.id,formData,usuario.idEscola)
        else
            addItem('turmas',formData,usuario.idEscola)
        cadastramento()
    }

    return(
        <ContainerForm cadastramento={cadastramento} finalizar={salvar}>
            <Input 
                label={'Nome'}
                name={'nome'}
                onChange={handleInputChange}
                value={formData.nome}
                required={true}
                placeholder={'Insira o nome da turma'}

            />
            <Input 
                label={'Descrição'}
                name={'descricao'}
                onChange={handleInputChange}
                value={formData.descricao}
                placeholder={'Ex: turma de obreiros'}
            />
            
                {Selection({
                    name:"grupo",
                    text:"Grupo",handleOnChange:handleInputChange,
                    options:grupos,
                    value:formData.grupo
                })}
           <Button type="submit">
                {edit? "Atualizar turma":"Cadastrar turma"}
           </Button>
        </ContainerForm>
    )
}

